import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, rem, Text, usePopoverContext } from '@bonusly/design-system';
import { useFeatureFlag, Variant } from '@bonusly/who-am-i';

import { useHashtagLink } from '../../../../../../modules/bonus-feed/features/recognition/hooks/useHashtagLink';
import { HashtagTrend } from '../../../types/hashtag';

interface HashtagDetailProps {
	hashtag: HashtagTrend;
}

export const HashtagDetail: FC<HashtagDetailProps> = ({ hashtag: { core_value, count, hashtag } }) => {
	const { t } = useTranslation('recognition');
	const hashtagLinkUrl = useHashtagLink(hashtag);
	const isHomepageRedesignEnabled = useFeatureFlag(Variant.HomepageRedesign);
	const navigate = useNavigate();
	const { onClose } = usePopoverContext();

	const handleClick = () => {
		onClose();
		window.scrollTo({ top: 0, behavior: 'smooth' });
		navigate(hashtagLinkUrl);
	};

	return (
		<Box>
			<Box mb={4}>
				<Text color="black" fontSize={rem(20)} fontWeight="medium">
					{hashtag}
				</Text>

				{!!count && (
					<Text color="gray.500" fontSize="sm" fontWeight="normal">
						{t('sidebar.trending.mentions_count', { count, context: 'full' })}
					</Text>
				)}
			</Box>

			{core_value && (
				<Text data-testid="core-value-description" color="gray.600" fontSize="md" mb={4} fontWeight="normal" whiteSpace="pre-wrap">
					{core_value.description}
				</Text>
			)}

			{isHomepageRedesignEnabled ? (
				<Button variant="alpha" w="full" onClick={handleClick}>
					{t('sidebar.trending.view_hashtag_button')}
				</Button>
			) : (
				<Button as="a" href={hashtagLinkUrl} variant="alpha" w="full">
					{t('sidebar.trending.view_hashtag_button')}
				</Button>
			)}
		</Box>
	);
};
